import { render, staticRenderFns } from "./TabsAlt.html?vue&type=template&id=51cb7587&scoped=true&"
import script from "./TabsAlt.js?vue&type=script&lang=js&"
export * from "./TabsAlt.js?vue&type=script&lang=js&"
import style0 from "./TabsAlt.scss?vue&type=style&index=0&id=51cb7587&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb7587",
  null
  
)

export default component.exports